// extracted by mini-css-extract-plugin
export default {"notify":"NotifyMe_notify__QVkFn","closeContainer":"NotifyMe_closeContainer__SKeJE","closeModal":"NotifyMe_closeModal__1uP5N"};